import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthService } from '../../services/auth/auth.service';
import { Router, RouterLink } from '@angular/router';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import {
  ScreenSizes,
  ScreenSizeService,
} from '../../services/screen-size/screen-size.service';
import { DatabaseService } from '../../database/database.service'
import { SnackbarService } from '../../services/snackbar/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { SelectWarehouseDialogComponent } from '../select-warehouse-dialog/select-warehouse-dialog.component';
import { LoginService } from '../../services/login/login.service';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatBadgeModule,
    MatMenuModule,
    BreadcrumbComponent,
    RouterLink,
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  public ELEMENT_IDS = ELEMENT_IDS;
  readonly dialog = inject(MatDialog);
  
  @Input() drawerSideNav!: MatSidenav;
  @Input() notificationDrawerSideNav!: MatSidenav;
  
  userData: any = {
    name: 'Loading...',
    role: '',
  };

  screenSize?: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private screenSizeService: ScreenSizeService,
    private databaseService: DatabaseService,
    private snackbarService: SnackbarService,
    private loginService: LoginService
  ) {
    this.screenSizeService.screenSize$.subscribe((size) => {
      this.screenSize = size;
    });

    const webUser = JSON.parse(localStorage.getItem('web_user')!);
    this.userData = {
      name: webUser?.description,
      role: webUser?.username // TODO: role description must be included on the response data for login
    }
  }

  openDrawer() {
    this.drawerSideNav.toggle();
  }

  openNotificationDrawer() {
    this.notificationDrawerSideNav.toggle();
  }

  onLogout() {
    this.authService.logout();
    this.databaseService.clearDatabase();
    this.snackbarService.closeAllSnackbar();
    this.router.navigate(['/login']);
  }

  onSelectWarehouse() {
    const dialogRef = this.dialog.open(SelectWarehouseDialogComponent, {
          width: '620px',
          maxWidth: 'none',
          data: {
            acceptedFileTypes: '.pdf',
            allowMultipleFiles: false,
          },
        });
        dialogRef.afterClosed().subscribe((selectedWarehouse) => {
          if (selectedWarehouse) {
            // this.uploadFile(file);
            // this.form.markAsDirty();
          }
        });
  }

  hasWarehouseOptions() {
    return this.loginService.availableWarehouse.length > 1;
  }

  getSelectedWarehouse() {
    const selectedWarehouse = this.loginService.selectedWarehouse;
    const defaultValue = this.loginService.availableWarehouse.find((item) => {
      return item.code === selectedWarehouse
    })
    return defaultValue?.description;
  }
}

const BASE_ELEMENT_ID: string = 'id_toolbar';
export const ELEMENT_IDS: { [key: string]: string } = {
  'cnt':                    BASE_ELEMENT_ID + '_cnt',
  'btn_menu_drawer':        BASE_ELEMENT_ID + '_btn_menu_drawer',
  'btn_account':            BASE_ELEMENT_ID + '_btn_account',
  'btn_select_warehouse':   BASE_ELEMENT_ID + '_btn_select_warehouse',
  'btn_change_password':    BASE_ELEMENT_ID + '_btn_change_password',
  'btn_contact_support':    BASE_ELEMENT_ID + '_btn_contact_support',
  'btn_sign_out':           BASE_ELEMENT_ID + '_btn_sign_out',
  'lbl_account_name':       BASE_ELEMENT_ID + '_lbl_account_name',
  'lbl_account_role':       BASE_ELEMENT_ID + '_lbl_account_role',
  'lbl_selected_warehouse': BASE_ELEMENT_ID + '_lbl_selected_warehouse',
};
